import React, { useState, useEffect } from 'react';
import DialogOTP from '../components/Complements/DialogOTP';
import CheckUser from '../components/Users/CheckUser';
import CheckId from '../components/Users/CheckId';
import LoadingScreen from '../components/Complements/LoadingScreen';
import FormQuestionDialogReduxForm from '../components/Questions/FormQuestionDialog';
import { feathersCreateData, feathersFindDataAllDefault } from '../services';
import { encrypt, decrypt } from './../functions/mobile';
import { isEmpty } from '../functions/arrays';

const RecoverContainer = props => {

    const { handleOpenSnack, recoveryType, getDeviceData, devices: deviceReduce } = props;

    const [loading, setLoading] = useState(false);
    const [openDialogOTP, setOpenDialogOTP] = useState(false)
    const [openDialogQuestions, setOpenDialogQuestions] = useState(false)
    const [dataQuestions, setDataQuestions] = useState([])
    const [questionSelected, setQuestionSelected] = useState({})
    const [valueForm, setValueForm] = useState("")
    const [dataUser, setDataUser] = useState("")
    const [positionQuestion, setPositionQuestion] = useState(0)
    const [dataDeviceCurrent, setDataDeviceCurrent] = useState({})

    //Carga Inicial

    const mount = () => {
        const unmount = () => {
            handleGetDataDevice()
        }

        return unmount()
    }

    useEffect(mount, [recoveryType])

    const handleGetDataDevice = async() => {

        try {
            
            let resultDevice = {}
            
            if (isEmpty(deviceReduce)) {
                const deviceInfo = await getDeviceData(null)
                resultDevice = deviceInfo.payload.data
            } else {
                resultDevice = deviceReduce
            }

            //console.log(resultDevice);

            const { ip, device, mac } = resultDevice

            setDataDeviceCurrent({
                ip,
                device,
                mac
            })

        } catch (error) {
            
        }
    }

    //Formulario Principal

    const handleSubmit = async(valuesForm) => {

        try {
            
            setLoading(true);

            setValueForm(valuesForm.identifier)

            let infoDeviceCurrent = {}

            if(dataDeviceCurrent.ip){
                infoDeviceCurrent = dataDeviceCurrent
            }else{
                let resultDevice = {}
            
                if (isEmpty(deviceReduce)) {
                    const deviceInfo = await getDeviceData(null)
                    resultDevice = deviceInfo.payload.data
                } else {
                    resultDevice = deviceReduce
                }
                const { ip, device, mac } = resultDevice

                infoDeviceCurrent = {
                    ip, 
                    device, 
                    mac
                }

                setDataDeviceCurrent(infoDeviceCurrent)
            }

            const sendData = encrypt(JSON.stringify({ 
                emited: 'NAV', 
                type: (!recoveryType) ? 11 : 12,
                user : valuesForm.identifier,
                change : (!recoveryType) ? 'contraseña' : 'usuario',   
                deviceData: infoDeviceCurrent.device, 
                ip : infoDeviceCurrent.ip, 
                mac : infoDeviceCurrent.mac
            }))

            const responseGenerateCode = await feathersCreateData("codes-recovery", { sendData })()

            //console.log(responseGenerateCode)

            const { responseData } = responseGenerateCode;

            const responseGenerateCodeDescrypt = JSON.parse(decrypt(responseData))

            //console.log(responseGenerateCodeDescrypt)

            const { alert, type } = responseGenerateCodeDescrypt;

            if (type === 'success') {

                setOpenDialogOTP(true);

            } else {

                handleOpenSnack(alert, type)
            }

            setLoading(false)

        } catch (error) {
            //console.log(error)
            setLoading(false)
            handleOpenSnack("Ha ocurrido un error al verificar el usuario.", "error");

        }
    }

    //Otp

    const handleCloseDialogOTP = () => {
        setOpenDialogOTP(false);
    }

    const handleChangeInputOtp = (valueinput) => {
        
        if(valueinput.target.value.toString().length === 4){
            receiveOTP({data : valueinput.target.value.toString()});
        }

    }

    const receiveOTP = async(valuesFormOtp) => {

        try {
            
            setLoading(true)

            const { data } = valuesFormOtp

            const sendData = encrypt(JSON.stringify({
                ip : dataDeviceCurrent.ip,
                mac : dataDeviceCurrent.mac,
                device : dataDeviceCurrent.device,
                type : (!recoveryType) ? 11 : 12,
                inputOtp : data
            }))
            
            const responseValidateCode = await feathersCreateData("code-validation", { sendData })()

            //console.log("Respuesta: ", responseValidateCode)

            //const responseValidateCodeDecrypt = JSON.parse(decrypt(responseValidateCode.responseData))

            //console.log(responseValidateCodeDecrypt)

            const { error, message, type, viewDialogOtp } = responseValidateCode;

            if(error === false){

                handleCloseDialogOTP()
                handleConsultQuestions(data)

            }else{

                if(viewDialogOtp === false){
                    handleCloseDialogOTP()
                }
                setLoading(false)
                handleOpenSnack(message, type);

            }

        } catch (error) {
            
            //console.log(error)
            setLoading(false)
            handleOpenSnack("Ha ocurrido al validar el código.", "error");
        }
    }

    //Questions

    const onCloseDialogQuestion = () => {
        setOpenDialogQuestions(false)
    }

    const handleSubmitQuestion = async(valuesFormQuestion) => {

        try {
            
            setLoading(true);

            let sendData = encrypt(JSON.stringify({
                ip : dataDeviceCurrent.ip, 
                mac : dataDeviceCurrent.mac,
                type : 24,
                device : dataDeviceCurrent.device, 
                answerQuestion : valuesFormQuestion.answer.toUpperCase(),
                idQuestion : questionSelected.id,
                cedule : dataUser,
                change : (!recoveryType) ? 'contraseña' : 'usuario',
            }))

            const responseValidationQuestions = await feathersCreateData("process-validation-user-question", { sendData })()

            const { responseData } = responseValidationQuestions;

            const responseValidationQuestionsDescrypt = JSON.parse(decrypt(responseData))

            //console.log(responseValidationQuestionsDescrypt)

            const { error, message, type, viewDialogQuestion } = responseValidationQuestionsDescrypt

            if(error === false){

                setOpenDialogQuestions(viewDialogQuestion)
                //handleGenerateOtp()

            }else{

                if(viewDialogQuestion === false){
                    setOpenDialogQuestions(viewDialogQuestion)
                }
                
            }

            handleOpenSnack(message, type)
            setLoading(false)

        } catch (error) {
            
            //console.log(error)
            setLoading(false)
            handleOpenSnack("Ha ocurrido un error al verificar la respuesta.", "error");
        }
    }

    const handleRefreshQuestion = () => {

        try {
            
            setLoading(true)

            if(positionQuestion < dataQuestions.length - 1){

                let newPosition = positionQuestion + 1;

                setQuestionSelected(dataQuestions[newPosition]);
                setPositionQuestion(newPosition);

            }else{

                setQuestionSelected(dataQuestions[0]);
                setPositionQuestion(0);

            }

            setLoading(false)

        } catch (error) {
            
            setLoading(false)
            handleOpenSnack("Ha ocurrido un error al cargar una nueva pregunta.", "error");
        }
    }

    const handleConsultQuestions = async(inputOtp) => {

        try {

            let query = (!recoveryType) ? {username : valueForm} : {vusk : valueForm}

            let sendData = encrypt(JSON.stringify({
                deviceData: dataDeviceCurrent.device, 
                ip : dataDeviceCurrent.ip, 
                mac : dataDeviceCurrent.mac,
                type : 24,
                query,
                change : (!recoveryType) ? 'contraseña' : 'usuario',
                typeOtp : (!recoveryType) ? 11 : 12,
                otp : inputOtp
            }))

            const responseQuestions = await feathersFindDataAllDefault("process-user-question", { sendData })()

            //console.log("response : ", responseQuestions)

            const { responseData } = responseQuestions;

            const responseQuestionsDescrypt = JSON.parse(decrypt(responseData))

            const { error, message, type } = responseQuestionsDescrypt

            if(error === false){

                const { user, questions } = responseQuestionsDescrypt.data;

                if(questions.length > 0){

                    let aleatorio = Math.floor(Math.random() * questions.length);
                    setPositionQuestion(aleatorio)
                    setDataUser(user.vusk)
                    setDataQuestions(questions)
                    setQuestionSelected(questions[aleatorio])
                    setOpenDialogQuestions(true)

                }else{
                    handleOpenSnack(message, type)
                }

            }else{
                handleOpenSnack(message, type)
            }

            setLoading(false)

        } catch (error) {
            
            setLoading(false)
            handleOpenSnack("Ha ocurrido un error al consultar las preguntas de seguridad.", "error");
        }
    }

    return (
        <div style = {{
            backgroundColor: "#0097a0",
            width : "100%",
            height : "100vh"
        }}>
            {
                (!recoveryType) ? 
                    <CheckUser 
                        onSubmit = { handleSubmit } 
                    /> :
                    <CheckId  
                        onSubmit = { handleSubmit } 
                        
                    />
            }
            <DialogOTP
                    openDialogOTP = {openDialogOTP}
                    loading = { loading }
                    initialTime = { Date.now() }
                    showQR = {false}
                    onCloseDialogOTP = { handleCloseDialogOTP }
                    onKeyPress = { handleChangeInputOtp }
                    OTPSubmit = { receiveOTP }
                    
                />
                <FormQuestionDialogReduxForm
                    questionSelected = { questionSelected }
                    openDialog = { openDialogQuestions }
                    onCloseDialogQuestion = { onCloseDialogQuestion }
                    onSubmit = { handleSubmitQuestion }
                    handleRefreshQuestion = { handleRefreshQuestion }
                />
                <LoadingScreen 
                    open={ loading } 
                />
        </div>
    )
}

export default RecoverContainer
